import { render, staticRenderFns } from "./RegistInfo.vue?vue&type=template&id=000efe1e&scoped=true&"
import script from "./RegistInfo.vue?vue&type=script&lang=js&"
export * from "./RegistInfo.vue?vue&type=script&lang=js&"
import style0 from "./RegistInfo.vue?vue&type=style&index=0&id=000efe1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000efe1e",
  null
  
)

export default component.exports